// notification delivery types
export const PushDeliveryType = 'push'
export const EmailDeliveryType = 'email'